export enum PhoneTypeEnum {
    None = "None",
    Home = "Home",
    Mobile = "Mobile",
    Work = "Work",
    Facility = "Facility",
    Office = "Office"
}
